import React, { useState, useEffect } from 'react'
import ItemCategoria from '../categoria-items/item-categoria';
import Carousel from 'react-multi-carousel';
import { imgtoJson } from '../../utils/helpers';
import { ColoresDPana, ColorsDPana } from '../../utils/Color';
import { categorias } from '../../models/categorias';
import { makeStyles } from '@mui/styles';
import 'react-multi-carousel/lib/styles.css';
import "./style.css";

const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        flexWrap: "wrap",
        alignItems: "center"
    },
    contentLineas: {
        width: "100%",
        position: "absolute",
        top: "0",
        marginTop: "10px"
    },
    Lineas: {
        backgroundColor: "white",
        width: "100%",
        height: "1px",
        marginTop: "5px",
    },
    carousel: {
        width: "100%",
        position: "relative",
        zIndex: 11
    },
    itemCarousel: {
        position: "relative",
        zIndex: 10
    }
});
interface CarouselProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    children?: React.ReactNode;
    className?: string;
    themeColor?: ColoresDPana;
    style?: React.CSSProperties;
    itemsCategroia: categorias[];
}


export default function CarouselComponent({ itemsCategroia: itemsCategoria, children, className, themeColor = ColorsDPana.sky_blue, style, ...restOfProps }: CarouselProps) {
    const classes = useStyles();
    const [CategoriaMenu, setCategoriaMenu] = useState<categorias[]>(itemsCategoria);
    const [esMoviendo, setesMoviendo] = useState(false)
    let isLoaded: boolean = false;
    let esClick: boolean = false;
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 18
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 9
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 4
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 3,
        }
    };

    useEffect(() => {
        setCategoriaMenu(itemsCategoria);
    })

    let carousel: Carousel | null;

    const onclick = (id: number, data: any) => {
        esClick = true;

    };
    const onScrollSection = (idx: number) => {
        if (idx && !esClick)
            try {
                if (carousel != null) {
                    if (idx - 1 <= (carousel.state.totalItems - carousel.state.slidesToShow)) {
                        carousel.goToSlide(idx);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        else
            esClick = false;
    }
    function antesmover(nextslide: number) {

    }
    function almover(nextslide: number) {


    }
    const convertImage = (item: string | undefined): string => {
        let s: string = item ? item.toString() : "";
        if (s.includes('[{' && '}]')) {
            try {
                s = imgtoJson(s);
                s = s.replace("http://localhost:8080/dl/sushibarstrike_v1_UD4u/", "http://sushibarstrike.com.ve/imagenes/");
            } catch (error) {

            } finally {
                return s;
            }
        } else return s;
    }
    return (

        <div className={classes.root}>
            <Carousel
                ref={(el) => (carousel = el as Carousel)}
                arrows={false}
                autoPlaySpeed={3000}
                centerMode={false}
                className=""
                containerClass={classes.carousel + " container"}
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={false}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                beforeChange={(e: any) => {
                    setesMoviendo(true);
                    almover(e);
                }}
                additionalTransfrom={10}
                afterChange={(e: any) => {
                    setesMoviendo(false);
                    antesmover(e);
                }}
            >
                {CategoriaMenu.map((data, index) => {
                    return <ItemCategoria className={classes.itemCarousel} key={index} idx={index} ID={data.ID} esActivo={data.esActivo == 1 ? true : false} Titulo={data.Nombre} handleScrollSection={() => { onScrollSection(index) }} handleClick={(e: any) => { onclick(index, e) }} Imagen={convertImage(data.ImagenWeb)}></ItemCategoria>
                })}

            </Carousel>


        </div >

    )
}



